// extracted by mini-css-extract-plugin
export default {"container":"LoginCTA_container__zi7k-","buttonsContainer":"LoginCTA_buttonsContainer__2s-wb"};